import PropTypes from "prop-types";
import styles from "./index.css";
import LastBestPrice from "../LastBestPrice";
import OriginalPriceExtended from "../OriginalPriceExtended";
import CurrentPrice from "../CurrentPrice";
import CurrentPriceExtendedPrefix from "../CurrentPriceExtendedPrefix";
import ProductPriceComponents from "../ProductPriceComponents";
import getPriceInfo from "../../../../getPriceInfo";
import OriginalPriceMarkup from "../OriginalPriceMarkup";

const ProductPriceComponentsExtended = ({
  showExtendedPricing,
  rowVisibilityRef,
  ...rest
}) => {
  if (!showExtendedPricing) {
    return (
      <ProductPriceComponents
        {...rest}
        rowVisibilityRef={rowVisibilityRef}
        OriginalPriceComponent={OriginalPriceMarkup}
      />
    );
  }

  const { discount, price, hasMultiplePricesInStock, variantId, labelledById } =
    rest;

  const priceInfo = getPriceInfo({ price });
  const { isDiscounted, isOutlet, originalPrice, currentPrice } = priceInfo;
  const { lowestPriceInLast30DaysValue, lowestPriceInLast30DaysPercentage } =
    price;

  const displayLastBestPrice = lowestPriceInLast30DaysValue !== null;

  return (
    <div className={styles.productPrice} id={labelledById} aria-hidden={true}>
      <CurrentPrice
        priceInfo={priceInfo}
        hasMultiplePricesInStock={hasMultiplePricesInStock}
        variantId={variantId}
        Prefix={CurrentPriceExtendedPrefix}
        rowVisibilityRef={rowVisibilityRef}
      />
      <span className={styles.screenReaderOnly}>;</span>
      {displayLastBestPrice && (
        <>
          <LastBestPrice
            lowestPriceInLast30DaysValue={lowestPriceInLast30DaysValue}
            lowestPriceInLast30DaysPercentage={
              lowestPriceInLast30DaysPercentage
            }
            currentPrice={currentPrice}
          />
          <span className={styles.screenReaderOnly}>;</span>
        </>
      )}
      {isDiscounted && (
        <OriginalPriceExtended
          isOutlet={isOutlet}
          originalPrice={originalPrice}
          discount={discount}
        />
      )}
    </div>
  );
};

ProductPriceComponentsExtended.propTypes = {
  price: PropTypes.shape({
    current: PropTypes.shape({ value: PropTypes.number.isRequired }).isRequired,
    previous: PropTypes.shape({ value: PropTypes.number }).isRequired,
    rrp: PropTypes.shape({ value: PropTypes.number }).isRequired,
    isOutletPrice: PropTypes.bool,
    lowestPriceInLast30DaysValue: PropTypes.number,
    lowestPriceInLast30DaysPercentage: PropTypes.number
  }).isRequired,
  hasMultiplePricesInStock: PropTypes.bool.isRequired,
  variantId: PropTypes.number,
  discount: PropTypes.number.isRequired,
  showDiscountLabel: PropTypes.bool.isRequired,
  showExtendedPricing: PropTypes.bool.isRequired,
  labelledById: PropTypes.string.isRequired,
  discountLabelledById: PropTypes.string,
  rowVisibilityRef: PropTypes.func
};

export default ProductPriceComponentsExtended;
